import React, { useState } from 'react';
import { FileUpload } from '../../../common/formElements/FileUpload';

const UploadCollectionDump = ({ projectId, collectionId, version }) => {
  const [dumpType, setDumpType] = useState('');
  const acceptedFile = () => {
    if (dumpType === 'CSV') {
      return '.csv';
    } else if (dumpType === 'MONGO_DUMP') {
      return '.bson';
    } else if (dumpType === 'JSON') {
      return '.json';
    }
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setDumpType(value);
  };

  const showFileType = () => {
    if (dumpType) {
      return (
        <div className="col-12 pt-3">
          <FileUpload
            url={`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/restore/${collectionId}/type/${dumpType}`}
            projectId={projectId}
            version={version}
            maxFiles={1}
            accept={acceptedFile()}
            maxSizeBytes="1000000"
            fileIcon="customTheme"
          />
        </div>
      );
    }
  };
  return (
    <div className="row mx-auto">
      <div className="col-12">
        <div className="row">
          <div className="col-sm-6 col-md-3 mt-4">Select Format</div>
          <div className="col-sm-6 col-md-6">
            <select
              name="dumpType"
              id="dumpType"
              className="form-control m-2"
              onChange={handleChange}
              value={dumpType}
            >
              <option value="">- Select Format -</option>
              <option value="CSV">CSV</option>
              <option value="JSON">JSON</option>
              <option value="MONGO_DUMP">Mongo Query</option>
            </select>
          </div>
          {showFileType()}
        </div>
      </div>
    </div>
  );
};

export default UploadCollectionDump;
